// Libraries import
import { useAxiosGet } from "../../services/useAxiosGet";

// Services import
import { useAppDispatch } from "../../redux/store/hook";
import { setDownloadDocumentsInfoAction } from "../../redux/appActions";

// Interfaces import
import { IDownloadDocumentsInformation } from "../../interfaces/interfaces";

// Interface delcaration
interface IFunctionReturn {
  requestDownloadDocumentsInfo: (
    userToken: string | null,
    userId: string | null
  ) => Promise<void>;
  isLoading: boolean;
  errorMessage: string;
}

// useGetDownloadDocumentsInfo : return tools to request the downloadable documents information to CRM and handle error
// Parameters
// ----------
// RAS
//
// Returns
// ----------
// Function requestDownloadDocumentsInfo
//     Function to call to send download document information request
// Boolean isLoading
//     Indicate if the asynchronous request is onGoing
// String errorMessage
//     Error message (no parameters or request error message)

export const useGetDownloadDocumentsInfo = (): IFunctionReturn => {
  // Get env. variable
  const BACKEND_URL = process.env.REACT_APP_API_AUTHENTICATION_URL;

  // Hooks calls
  const dispatch = useAppDispatch();
  const {
    axiosGetRequest,
    isLoading,
    errorMessage: axiosErrorMessage,
  } = useAxiosGet();

  // requestDownloadDocumentsInfo : send get download documents information request
  // Parameters
  // ----------
  // userToken: String | null
  //      the JWT authentication token of the user
  // userId: String | null
  //      the unique id of the project
  // Returns
  // ----------
  // Void

  const requestDownloadDocumentsInfo = async (
    userToken: string | null,
    userId: string | null
  ): Promise<void> => {
    const response = await axiosGetRequest<IDownloadDocumentsInformation[]>(
      `${BACKEND_URL}/api/User/${userId}/GetMyAdminDocs`,
      {
        headers: {
          authorization: `Bearer ${userToken}`,
        },
      }
    );
    // If we have at least one document in the reponse array, we save the download document information in redux store
    if (response && response.data?.length > 0) {
      dispatch(
        setDownloadDocumentsInfoAction({ downloadDocumentsInfo: response.data })
      );
    }
  };

  return {
    requestDownloadDocumentsInfo,
    isLoading,
    errorMessage: axiosErrorMessage,
  };
};
